import React from 'react'
import { Button, Form, Input, Modal, message } from 'antd'
import validator from '../../../validator'
import { observer } from 'mobx-react'
import PlusOutlined from '@ant-design/icons/lib/icons/PlusOutlined'
import createMyFolderStore from './createMyFolderStore'

const CreateMyFolderModal = props => {
  const { visible, parentFolderId, typeTab, onClose } = props
  const { isLoading } = createMyFolderStore
  const [form] = Form.useForm()

  const onFinish = values => {
    const { folder_name } = values
    const fileParam = {
      name: folder_name,
      parentId: parentFolderId,
      type: 'folder',
      typeTab,
    }

    createMyFolderStore
      .create(fileParam)
      .then(() => {
        closeAndResetForm()
      })
      .catch(e => {
        createMyFolderStore.isLoading = false
        message.error(e?.vi || 'Đã có lỗi xảy ra!')
      })
  }

  const closeAndResetForm = () => {
    form.resetFields()
    onClose()
  }

  return (
    <Modal
      footer={null}
      closable={true}
      visible={visible}
      onCancel={closeAndResetForm}
      title="Tạo thư mục">
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          name="folder_name"
          rules={[
            { required: true, message: 'Vui lòng nhập tên thư mục!' },
            { validator: validator.validateInputString },
          ]}
          label="Tên thư mục:">
          <Input placeholder="Nhập tên thư mục" />
        </Form.Item>
        <Form.Item>
          <Button
            icon={<PlusOutlined />}
            loading={isLoading}
            htmlType="submit"
            type="primary">
            Tạo
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default observer(CreateMyFolderModal)

